import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_bold_playful_home: FaireThemeEntity = {
  token: "discovery_theme_bold-playful-home",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Bold & playful home accents",
  description: "Vibrant accents to liven up any room",
  bgColor: "#F5E6C8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
